import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { PaginatedResponse, Product } from '~shared/models';
import {
  API_BEST_SELLING_PRODUCTS_LIST,
  BEST_SELLING_PRODUCTS_LIMIT,
  BEST_SELLING_PRODUCTS_OFFSET,
} from '../constants';
import { queryBuilder } from '@metromarkets/sdk';
import { map } from 'rxjs/operators';
import { SearchHttpService } from '~app/modules/generic/services/search-http.service';
import { RegionSelectorService } from '~shared/modules/region-selector/services';

@Injectable({
  providedIn: 'root',
})
export class BestSellingProductsService {
  constructor(private searchHttpService: SearchHttpService, private regionSelectorService: RegionSelectorService) {}

  getProducts(categoriesSlugs: string[], limit?: number, offset?: number): Observable<Product[]> {
    const params = queryBuilder.toParams({
      filter: {
        categories: categoriesSlugs,
      },
      limit: limit || BEST_SELLING_PRODUCTS_LIMIT,
      offset: offset || BEST_SELLING_PRODUCTS_OFFSET,
      ...(this.regionSelectorService.userRegion$ && { region: this.regionSelectorService.getUserRegion() }),
    }) as HttpParams;

    return this.searchHttpService.getPaginatedProducts(API_BEST_SELLING_PRODUCTS_LIST(), params, 'angular_best_selling_products').pipe(
      map((response: PaginatedResponse<Product>) => {
        return response.items.map((item) => Product.map(item));
      })
    );
  }
}
